import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { interceptorProviders } from './interceptors/interceptors';
// import { ConfirmationDialogComponent } from '../shared/components/confirmation-dialog/confirmation-dialog.component';
// import { ConfirmationDialogService } from '../shared/services/confirmation/confirmation-dialog.service';

@NgModule({
  declarations: [
    // ConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    // MaterialModule,
    HttpClientModule
  ],
  providers: [interceptorProviders, 
    // ConfirmationDialogService
  ]
})
export class CoreModule { }
